import {useContext} from 'react';
import {UserInteractionContext, UserInteractionContextProps} from './context';

export function useUserInteraction(): UserInteractionContextProps {
	const ctx = useContext(UserInteractionContext);

	if (!ctx) throw new Error('No confirmation context found!');

	return ctx;
}
